import { getApp } from 'actions/app'
import { BrameCampaign } from 'api/brameCampaigns'
import { useBrameIntegration } from 'api/integrationsConfig'
import Spinner from 'components/Spinner'
import useDispatch from 'hooks/useDispatch'
import { buildTranslate } from 'locales'
import { useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import { useSelector } from 'react-redux'
import AddGameFormContainer from 'scenes/Games/AddGameForm/AddGameFormContainer'
import GamesHeader from 'scenes/Games/components/GamesHeader'
import GamesDisabled from 'scenes/Games/GamesIntegrationDisabled'
import GamesEnabled from 'scenes/Games/GamesIntegrationEnabled'
import GamesTabs from 'scenes/Games/GamesIntegrationEnabled/GamesTabs'
import { selectApp } from 'selectors/app'

const t = buildTranslate('games')

type GameTab = 'collection' | 'activity'
type GameView = 'collection' | 'addForm'

const Landing = () => {
  const dispatch = useDispatch()
  const app = useSelector(selectApp)
  const { brameIntegrationEnabled: integrationEnabled, isLoading } =
    useBrameIntegration()

  const [activeTab, setActiveTab] = useState<GameTab>('collection')
  const [currentView, setCurrentView] = useState<GameView>('collection')
  const [editingGame, setEditingGame] = useState<BrameCampaign | null>(null)
  const [isAppLoading, setIsAppLoading] = useState(!app)

  useEffect(() => {
    if (app) {
      setIsAppLoading(false)
    } else {
      setIsAppLoading(true)
      dispatch(getApp())
    }
  }, [dispatch, app])

  const handleAddGame = () => {
    setEditingGame(null)
    setCurrentView('addForm')
  }

  const handleEditGame = (game: BrameCampaign) => {
    setEditingGame(game)
    setCurrentView('addForm')
  }

  const handleCancelAddGame = () => {
    setEditingGame(null)
    setCurrentView('collection')
  }

  const handleSaveGame = () => {
    setEditingGame(null)
    setCurrentView('collection')
  }

  // Show add game form
  if (currentView === 'addForm') {
    return (
      <div className="full-height">
        <Helmet>
          <title>{t('pageTitle')}</title>
        </Helmet>
        <AddGameFormContainer
          onCancel={handleCancelAddGame}
          onSave={handleSaveGame}
          editingGame={editingGame}
        />
      </div>
    )
  }

  if (isLoading || isAppLoading) {
    return (
      <div className="full-height grey-05-bkg">
        <Helmet>
          <title>{t('pageTitle')}</title>
        </Helmet>
        <Spinner
          isLoading={true}
          size="3x"
          className="d-flex justify-content-center mt-xxl"
        />
      </div>
    )
  }

  return (
    <div className="full-height grey-05-bkg">
      <Helmet>
        <title>{t('pageTitle')}</title>
      </Helmet>

      <GamesHeader>
        {integrationEnabled && (
          <GamesTabs activeTab={activeTab} onTabChange={setActiveTab} />
        )}
      </GamesHeader>

      <div className="pb-xxl" style={{ backgroundColor: '#fff' }}>
        {integrationEnabled ? (
          <GamesEnabled
            activeTab={activeTab}
            onAddGame={handleAddGame}
            onEditGame={handleEditGame}
          />
        ) : (
          <GamesDisabled />
        )}
      </div>
    </div>
  )
}

export default Landing
